import { planTypes } from '@/common/constants';

export const dependBasePlanTypeList = [planTypes.ZOOM_CLIPS, planTypes.ZOOM_MEETING, planTypes.ZONE_EDU_PLUS, planTypes.ZONE_BASIC_PLUS , planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE]
